import { Component, ViewEncapsulation } from '@angular/core';
import { AndFilter, Filter, FilterOperation, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import { TransactionsService } from '../_services/transactions.service';
import { TransactionsTypesService } from '../_services/transactions-types.service';
import { JobsService } from '../../cases/_services/jobs.service';
import { Job } from '../../cases/_types/job';
import { BusinessService } from '../../business/_services/business.service';
import { AccordionTabOpenEvent } from 'primeng/accordion';
import { WorkersService } from '../../workers/_services/workers.service';
import { Worker } from '../../workers/_types/worker';
import { WorkerBillableItemsService } from '../../workers/_services/workers-billable-items.service';
import { TransactionsStatesService } from '../_services/transactions-states.service';
import moment from 'moment';
import { WorkerBillableItemLinesService } from '../../workers/_services/workers-billable-item-lines.service';
import { WorkerBillableItemLine } from '../../workers/_types/worker-billable-item-line';
import { date } from '@rxweb/reactive-form-validators';
import { ConfigurationsService } from '../../common/_services/configurations.service';

@Component({
    selector: 'app-transactions-workers',
    templateUrl: './transactions-workers.component.html',
    styleUrls: ['./transactions-workers.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TransactionsWorkersComponent {

  public loading: boolean = false;
  public type!: string;

  private lastGridEvent: any;
  public filters: any = {
    dateFrom: moment().add('month', -1).set('date', 26).toDate(),
    dateTo: moment().set('date', 25).toDate()
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public jobsCaseServices: any[] = [];
  public jobs: Job[] = [];

  public workers: Worker[] = [];
  public business: any = [];
  public selectedLines: Job[] = [];
  public displayModal: boolean = false;
  public selectedDate: Date = new Date();


  public workerBusinesses: any[] = [];

  public selectedWorkers: Record<string, boolean> = {};
  public selectedCases: Record<string, any[]> = {};
  public selectedBillableItems: { [key: string]: any[] } = {};
  public selectedChargedByWorker: { [key: string]: any[] } = {};
  public transaction: any = null;
  public allOpenIndexes: number[] = [];

  public isAdvancePayment: boolean = false;
  //valor por defecto si la configuracion ANTICIPO no existe
  public advancePaymentPercent: number = 5;

  constructor(
    private route: ActivatedRoute,
    public topbarService: TopbarService,
    private jobsService: JobsService,
    private workersService: WorkersService,
    private businessService: BusinessService,
    private messageService: MessageService,
    private transactionsService: TransactionsService,
    private confirmationService: ConfirmationService,
    private workersBillableItemsService: WorkerBillableItemsService,
    private workersBillableItemLinesService: WorkerBillableItemLinesService,
    private transactionsStatesService: TransactionsStatesService,
    private configurationsService: ConfigurationsService,
    private router: Router
  ) {


    this.allowWrite = true;
    this.allowDelete = true;
  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(() => {
      this.type = this.route.snapshot.params['type'];
      //Si es de tipo "worker_invoice_reques" cargamos los datos de transaccion
      /*if (this.type == "worker_invoice_request") {
        this.loadTransaction(this.route.snapshot.params['transactionId']);
      } else {
        //this.loadData();
      }*/
    });

    this.loadWorkers();
    this.loadBusiness();

    if (this.type == "incoming_invoice") {
      this.loadAdvancePaymentPercent();
    }

    this.selectedLines = [];

  }

  async loadAdvancePaymentPercent() {
    let filters = {
      code: new Filter(FilterOperation.equals, 'code', '', 'ANTICIPO')
    };
    let params: IParamsCollection = {
      page: { size: 1 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.configurationsService.all(params));
    if (response.meta['total'] > 0) {
      let value = Number(response.data[0].value);
      if (!isNaN(value)) this.advancePaymentPercent = value;
    }
  }

  async loadData() {
    this.loading = true;
    this.selectedCases = {};
    this.selectedBillableItems = {};
    this.selectedChargedByWorker = {};

    /*let validCompaniesIds:string[] = [
      '34E90C57-7FCC-4C6B-ACE6-08DD30B6B9CE', //asitur
      'D1460C1C-2A0D-49DF-FB1D-08DD76A68D06', //ima
      '9394ADB8-97E0-4388-F290-08DD76A8FBA7', //prestima
      '20D353C6-A3B6-4B68-7FD0-08DDD8C293C8', //santander
      '4ce7851d-e8a7-4bea-e819-08dd33aeb84e', //multi
      '6573e327-6739-4c84-94ab-08dd4d2578bf', //generali
      '24777640-af9a-4af1-e02b-08ddf084756d', //linea direct
      'fc096971-99de-4e4e-a7f6-08de2d939493', //kutcha
    ];*/

    let paramsJobs: IParamsCollection = {};
    let filtersJobs: any = {
      isBillable: new Filter(FilterOperation.equals, "isBillable", "", true),
      isReview: new Filter(FilterOperation.equals, "isReview", "", true),
      transactionId: new Filter(FilterOperation.equals, "transactionId", "", null, true),
      workerId: new NotFilter(FilterOperation.equals, "workerId", "", null, true),
      isForCompany: new Filter(FilterOperation.equals, "isForCompany", "", false),
      workerBillableItemLineId: new Filter(FilterOperation.equals, "workerBillableItemLineId", "", null, true),
      //companyId: new Filter(FilterOperation.any, "case.companyId", "", validCompaniesIds),
      hasSubmitInvoice: new Filter(FilterOperation.equals, "worker.hasSubmitInvoice", "", false),
      typeOfBusiness: new NotFilter(FilterOperation.equals, "worker.typeOfBusiness", "", "Staff"),
      hasParentSubmitInvoice: new OrFilter([        
        new Filter(FilterOperation.equals, "worker.parentWorkerId", "", null, true),
        new Filter(FilterOperation.equals, "worker.parentWorker.hasSubmitInvoice", "", false),
        new NotFilter(FilterOperation.equals, "worker.parentWorker.typeOfBusiness", "", "Staff")        
      ])
      
    };

    if (this.filters.workerId != null && this.filters.workerId != "null") {
      filtersJobs.workerId = new OrFilter([
        new Filter(FilterOperation.equals, "workerId", "", this.filters.workerId),
        new Filter(FilterOperation.equals, "worker.parentWorkerId", "", this.filters.workerId)
      ]);
    }

    if (this.filters.businessId != null && this.filters.businessId != "null") {
      filtersJobs.businessId = new Filter(FilterOperation.equals, "case.contract.business.id", "", this.filters.businessId);
    }

    if (this.filters.dateFrom) {
      let dateFrom = moment(this.filters.dateFrom).startOf('day').toDate();
      filtersJobs.dateFrom = new Filter(FilterOperation.greaterOrEqual, "date", "", dateFrom.toISOString());
    }

    if (this.filters.dateTo) {
      let dateTo = moment(this.filters.dateTo).startOf('day').add(1, 'day').add(-1, 'second').toDate();
      filtersJobs.dateTo = new Filter(FilterOperation.lessOrEqual, "date", "", dateTo.toISOString());
    }

    // Primera petición: isForCompany == false
    paramsJobs.page = { size: 100000 };
    paramsJobs.filter = FilterBuilder.fromObject(filtersJobs).build();
    paramsJobs.sort = ['date', 'worker.name'];
    paramsJobs.include = [
      'caseService',
      'worker.parentWorker',
      'case',
      'case.caseType',
      'case.contract.business',
      'case.client',
      'rateLine'
    ];
    paramsJobs.fields = {
      jobs: 'id,caseId,case,workerId,worker,rateLineId,rateLine,date,description,quantity,unitPrice,taxPercent,taxAmount,total,isForCompany,chargedByWorker,chargedTransactionId',
      caseServices: 'id,date',
      caseTypes: 'id,name',
      cases: 'id,reference,caseNumber,caseDate,caseTypeId,contractId,clientId,contract,caseType,client',
      contracts: 'id,billingCompanyId,business',
      workers: 'id,name,vatNumber,parentWorkerId,parentWorker',
      clients: 'id,name',
      rateLines: 'id,displayName',
      businesses: 'id,name'
    };
    let response = await firstValueFrom(this.jobsService.all(paramsJobs));
    let jobs = response.data;

    // Segunda petición: isForCompany == true && chargedByWorker == true
    let filtersCompanyJobs: any = {
      isForCompany: new Filter(FilterOperation.equals, "isForCompany", "", true),
      chargedByWorker: new Filter(FilterOperation.equals, "chargedByWorker", "", true),
      isBillable: new Filter(FilterOperation.equals, "isBillable", "", true),
      chargedTransactionId: new Filter(FilterOperation.equals, "chargedTransactionId", "", null, true),
      workerId: new NotFilter(FilterOperation.equals, "workerId", "", null, true),
      //companyId: new Filter(FilterOperation.any, "case.companyId", "", validCompaniesIds),
      hasSubmitInvoice: new Filter(FilterOperation.equals, "worker.hasSubmitInvoice", "", false),
      typeOfBusiness: new NotFilter(FilterOperation.equals, "worker.typeOfBusiness", "", "Staff"),
      hasParentSubmitInvoice: new OrFilter([        
        new Filter(FilterOperation.equals, "worker.parentWorkerId", "", null, true),
        new Filter(FilterOperation.equals, "worker.parentWorker.hasSubmitInvoice", "", false),
        new NotFilter(FilterOperation.equals, "worker.parentWorker.typeOfBusiness", "", "Staff")
      ])
    };

    if (this.filters.workerId != null && this.filters.workerId != "null") {
      filtersCompanyJobs.workerId = new Filter(FilterOperation.equals, "workerId", "", this.filters.workerId);
    }

    if (this.filters.businessId != null && this.filters.businessId != "null") {
      filtersCompanyJobs.businessId = new Filter(FilterOperation.equals, "case.contract.business.id", "", this.filters.businessId);
    }

    if (this.filters.dateFrom) {
      let dateFrom = moment(this.filters.dateFrom).startOf('day').toDate();
      filtersCompanyJobs.dateFrom = new Filter(FilterOperation.greaterOrEqual, "date", "", dateFrom.toISOString());
    }

    if (this.filters.dateTo) {
      let dateTo = moment(this.filters.dateTo).startOf('day').add(1, 'day').add(-1, 'second').toDate();
      filtersCompanyJobs.dateTo = new Filter(FilterOperation.lessOrEqual, "date", "", dateTo.toISOString());
    }

    let paramsCompanyJobs: IParamsCollection = {
      page: { size: 100000 },
      filter: FilterBuilder.fromObject(filtersCompanyJobs).build(),
      include: paramsJobs.include,
    };

    let responseCompanyJobs = await firstValueFrom(this.jobsService.all(paramsCompanyJobs));
    let companyJobs = responseCompanyJobs.data;

    // Fusión de ambos resultados (evitando duplicados si es necesario)
    let mergedJobs = [...jobs, ...companyJobs];
    
    const jobsSummary = mergedJobs.reduce((acc, job) => {      

      let worker = job.worker;
      if(job.worker?.parentWorkerId!=null) worker = job.worker.parentWorker;

      //si worker es nulo lo saltamos
      if (worker == null) return acc;

      if(job.case?.contract==null || job.case?.contract.billingCompanyId==null) console.error("Null contract for job", job);
      let workerBusinessKey = `${worker.id}|${job.case?.contract?.billingCompanyId}`;

      // Si no existe la clave en el acumulador, la inicializamos
      if (!acc[workerBusinessKey]) {
        acc[workerBusinessKey] = {
          workerId: worker.id!,
          workerName: worker.name,
          workerVat: worker.vatNumber,
          businessId: job.case?.contract?.billingCompanyId,
          businessName: job.case?.contract?.business?.name,
          subtotal: 0,
          taxAmount: 0,
          total: 0,
          cases: {} as Record<string, { caseId: string; reference: string; caseNumber: string; date: Date; jobId: string; jobDate: Date; type: string; clientName: string; subtotal: number; taxAmount: number; total: number }>,
          billableItems: {} as Record<string, { id: string; description: string; quantity: number; price: number; taxName: string; taxAmount: number; type: string; /*hours: number*/ }>,
          chargedByWorker: {} as Record<string, { id: string; caseId: string; reference: string; caseNumber: string;date: Date; description: string; quantity: number; price: number; taxName: string; taxAmount: number; type: string; /*hours: number*/ }>
        };
      }

      if ((job.chargedByWorker == false || job.chargedByWorker == null) && !job.isForCompany && (job.workerId == worker.id || job.worker?.parentWorkerId == worker.id)) {

        // Si el caseId no existe en este worker + business, lo inicializamos
        //if (!acc[workerBusinessKey].cases[job.id!]) {
          acc[workerBusinessKey].cases[job.id!] = {
            caseId: job.caseId,
            reference: job.case?.reference,
            caseNumber: job.case?.caseNumber,
            date: job.caseService?.date,
            jobId: job.id!,
            jobDate: job.date,
            type: job.case?.caseType?.name,
            clientName: job.case?.client?.name??'-',
            subtotal: job.unitPrice * job.quantity,
            taxAmount: job.taxAmount,
            total: job.total
          };
        //}

        // Sumar valores al operario en este negocio
        acc[workerBusinessKey].subtotal += job.unitPrice * job.quantity;
        acc[workerBusinessKey].taxAmount += job.taxAmount;
        acc[workerBusinessKey].total += job.total;
      }


      if (this.type != "worker_invoice_request" && job.isForCompany && job.chargedByWorker == true && job.chargedTransactionId == null) {

        acc[workerBusinessKey].subtotal += (job.unitPrice * -1) * job.quantity;
        acc[workerBusinessKey].taxAmount += job.taxAmount * -1;
        acc[workerBusinessKey].total += job.total * -1;

        // Sumar valores al operario en este negocio
        acc[workerBusinessKey].chargedByWorker[job.id!] = {
          id: job.id!,
          caseId: job.caseId,
          reference: job.case?.reference,
          caseNumber: job.case?.caseNumber,
          date: job.date,
          //description: job.rateLine!=null?job.rateLine.displayName:job.description,
          description: job.rateLineDescription ?? job.description,
          quantity: job.quantity,
          price: job.unitPrice * -1,
          taxName: job.taxPercent + "%",
          taxAmount: job.taxAmount * -1,
          type: "chargedByWorker"
        };

      }

      return acc;


    }, {} as Record<string, {
      workerId: string; workerName: string; workerVat: string; businessId: string; businessName: string; subtotal: number; taxAmount: number; total: number;
      cases: Record<string, { caseId: string; reference: string; caseNumber: string; date: Date; jobId: string; jobDate: Date; type: string; clientName: string; subtotal: number; taxAmount: number; total: number }>
      billableItems: Record<string, { id: string; description: string; quantity: number; price: number; taxName: string; taxAmount: number; type: string; /*hours: number*/ }>
      chargedByWorker: Record<string, { id: string; caseId: string; reference: string; caseNumber: string;date: Date; description: string; quantity: number; price: number; taxName: string; taxAmount: number; type: string; /*hours: number*/ }>
    }>);

    //obtenemos los billable items de los operarios para mostrarlos en la factura
    let dateFrom = moment(this.filters.dateFrom).startOf('day').toDate();
    let dateTo = moment(this.filters.dateTo).startOf('day').add(1, 'day').add(-1, 'second').toDate();
    let filters: any = {
      transactionId: new Filter(FilterOperation.equals, "transactionId", "", null, true),
      workerId: new OrFilter([
        new Filter(FilterOperation.equals, "workerId", "", this.filters.workerId),
        new Filter(FilterOperation.equals, "worker.parentWorkerId", "", this.filters.workerId)
      ]),
      dateFrom: new Filter(FilterOperation.greaterOrEqual, "date", "", dateFrom.toISOString()),
      dateTo: new Filter(FilterOperation.lessOrEqual, "date", "", dateTo.toISOString())
    }
    let params: IParamsCollection = {
      page: { size: 100000 },
      filter: FilterBuilder.fromObject(filters).build(),
      include: ['worker', 'tax']
    };
    let workerBillableItemLinesResponse = await firstValueFrom(this.workersBillableItemLinesService.all(params));
    let jobsSummaryKeys = Object.keys(jobsSummary);

    workerBillableItemLinesResponse.data.forEach(item => {
      //let workerBusinessKey = `${item.workerId}|${item.businessId}`;

      let workerId = item.workerId;
      if(item.worker?.parentWorkerId!=null) workerId = item.worker.parentWorkerId;

      //buscamos los jobSummary del worker de la empresa que tenga mayor total de facturación
      let jobSummary:any = null;
      for(let key of jobsSummaryKeys){
        if(key.startsWith(workerId) && (jobSummary==null || (jobsSummary[key].total > jobSummary.total))) jobSummary = jobsSummary[key];
      }

     /* if(jobSummary == null){
        jobsSummary[workerId] =  {
          workerId: workerId,
          workerName: item.worker?.name,
          workerVat: item.worker?.vatNumber,
          businessId: "?????",
          businessName: "?????",
          subtotal: 0,
          taxAmount: 0,
          total: 0,
          cases: {} as Record<string, { caseId: string; reference: string; caseNumber: string; date: Date; jobId: string; jobDate: Date; type: string; clientName: string; subtotal: number; taxAmount: number; total: number }>,
          billableItems: {} as Record<string, { id: string; description: string; quantity: number; price: number; taxName: string; taxAmount: number; type: string;  }>,
          chargedByWorker: {} as Record<string, { id: string; caseId: string; reference: string; caseNumber: string;date: Date; description: string; quantity: number; price: number; taxName: string; taxAmount: number; type: string;}>
        };
        jobSummary = jobsSummary[workerId];
      }*/

      //añadimos el item al jobSummary que corresponda
      if(jobSummary!=null){
        jobSummary.billableItems[item.id!] = {
          id: item.id,
          description: item.description,
          quantity: item.quantity,
          price: item.price,
          taxName: item.tax.name,
          taxAmount: item.taxAmount,
          type: 'workerBillableItems'
        };

        // Sumar valores al workerBusiness
        jobSummary.subtotal += item.subtotal;
        jobSummary.taxAmount += item.taxAmount;
        jobSummary.total += item.total;
      }
    });

    // Convertir a array para el HTML
    this.workerBusinesses = Object.values(jobsSummary).map(workerBusiness => ({
      ...workerBusiness,
      cases: Object.values(workerBusiness.cases) // Convertimos los casos a array
    }));
    
    // Inicializar selección de checkboxes
    if (this.type != "worker_invoice_request") {
      this.workerBusinesses.forEach(workerBusiness => {
        //if (workerBusiness.workerVat) {
        const key = `${workerBusiness.workerId}|${workerBusiness.businessId}`;
        this.selectedCases[key] = [];
        this.selectedWorkers[key] = true;
        this.selectedCases[key] = [...workerBusiness.cases];
        //}
      });
    } else {
      this.workerBusinesses.forEach(workerBusiness => {
        const key = `${workerBusiness.workerId}|${workerBusiness.businessId}`;
        const cases = [...workerBusiness.cases];

        // Ordenar de mayor a menor según total
        cases.sort((a, b) => (b.total ?? 0) - (a.total ?? 0));

        this.selectedCases[key] = [];
        let accumulated = 0;

        for (const c of cases) {
          const caseTotal = c.total ?? 0;

          if (caseTotal >= this.transaction.total) {
            this.selectedCases[key].push(c);
            accumulated += caseTotal;
            break;
          }

          if (accumulated >= this.transaction.total) {
            break;
          }

          this.selectedCases[key].push(c);
          accumulated += caseTotal;
        }
      });
    }

    // Convertir a array para el HTML
    this.workerBusinesses = Object.values(jobsSummary).map(workerBusiness => ({
      ...workerBusiness,
      cases: Object.values(workerBusiness.cases),  // Convertimos los casos a array
      billableItems: Object.values(workerBusiness.billableItems), // Convertimos los billableItems a array
      chargedByWorker: Object.values(workerBusiness.chargedByWorker) // Convertimos los chargedByWorker a array
    }));

    // Inicializar selección de checkboxes
    this.workerBusinesses.forEach(workerBusiness => {
      //if (workerBusiness.workerVat) {
      const key = `${workerBusiness.workerId}|${workerBusiness.businessId}`;
      this.selectedBillableItems[key] = [];
      if (this.type != "worker_invoice_request") { this.selectedWorkers[key] = true; }
      this.selectedChargedByWorker[key] = [...workerBusiness.chargedByWorker];
      this.selectedBillableItems[key] = [...workerBusiness.billableItems];
      //}
    });

    //ordenamos por nombre de operario y luego por nombre de sociedad
    this.workerBusinesses = this.workerBusinesses.sort((a, b) => {
      const workerComparison = a.workerName.localeCompare(b.workerName);
      if (workerComparison !== 0) {
        return workerComparison;
      }
      return a.businessName.localeCompare(b.businessName);
    });

    this.loading = false;
    if (this.type == "worker_invoice_request") this.allOpenIndexes = this.workerBusinesses.map((_, index) => index);
  }


  async loadTransaction(transactionId: string) {
    let params: IParamsCollection = {
      include: ['thirdParty'],
    }

    let response: any = await firstValueFrom(this.transactionsService.get(transactionId, params));

    this.transaction = response;

    this.filters.workerId = response.thirdPartyId;

    this.loadData();
  }

  toggleAllCases(workerId: string, businessId: string, checked: boolean) {
    let key = `${workerId}|${businessId}`;
    this.selectedWorkers[key] = checked;

    if (checked) {
      let workerBusiness = this.workerBusinesses.find(wb =>
        wb.workerId === workerId && wb.businessId === businessId
      );

      // Seleccionar todos los casos y billable items de ese workerBusiness
      this.selectedCases[key] = [...(workerBusiness?.cases || [])];
      this.selectedBillableItems[key] = [...(workerBusiness?.billableItems || [])];
      this.selectedChargedByWorker[key] = [...(workerBusiness?.chargedByWorker || [])];

    } else {
      this.selectedCases[key] = [];
      this.selectedBillableItems[key] = [];
      this.selectedChargedByWorker[key] = [];
    }

    this.updateHeaderTotals(workerId, businessId);
  }


  updateHeaderCheckboxState(workerId: string, businessId: string) {
    let key = `${workerId}|${businessId}`;
    const workerBusiness = this.workerBusinesses.find(wb => wb.workerId === workerId && wb.businessId === businessId);

    if (workerBusiness) {
      this.selectedWorkers[key] = workerBusiness.cases.length > 0 &&
        workerBusiness.cases.every((c: any) => this.selectedCases[key]?.includes(c));
    }
  }

  updateWorkerBusinessTotals(workerId: string, businessId: string) {
    const key = `${workerId}|${businessId}`;
    const workerBusiness = this.workerBusinesses.find(wb =>
      wb.workerId === workerId && wb.businessId === businessId
    );

    if (!workerBusiness) return;

    // Obtener todos los ítems seleccionados
    const selectedCases = this.selectedCases[key] || [];
    const selectedBillableItems = this.selectedBillableItems[key] || [];
    const selectedChargedByWorker = this.selectedChargedByWorker[key] || [];

    // Calcular subtotales y taxes por tipo
    const casesSubtotal = selectedCases.reduce((sum, c) => sum + (c.subtotal || 0), 0);
    const casesTax = selectedCases.reduce((sum, c) => sum + (c.taxAmount || 0), 0);

    const billableSubtotal = selectedBillableItems.reduce((sum, item) => sum + ((item.price || 0) * (item.quantity || 0)), 0);
    const billableTax = selectedBillableItems.reduce((sum, item) => sum + (item.taxAmount || 0), 0);
    
    const chargedSubtotal = selectedChargedByWorker.reduce((sum, item) => sum + ((item.price || 0) * (item.quantity || 0)), 0);
    const chargedTax = selectedChargedByWorker.reduce((sum, item) => sum + (item.taxAmount || 0), 0);
    
    const totalSubtotal = casesSubtotal + billableSubtotal + chargedSubtotal;
    const totalTax = casesTax + billableTax + chargedTax;

    workerBusiness.subtotal = totalSubtotal;
    workerBusiness.taxAmount = totalTax;
    workerBusiness.total = totalSubtotal + totalTax;
  }


  async loadWorkers() {
    let allWorkers = new Worker();
    allWorkers.id = "null";
    allWorkers.name = "Todos";
    let filter:any = {
      notParentWorkerId: new Filter(FilterOperation.equals, "parentWorkerId", "", null, true),
      hasSubmitInvoice: new Filter(FilterOperation.equals, "hasSubmitInvoice", "", false),
      typeOfBusiness: new NotFilter(FilterOperation.equals, "typeOfBusiness", "", "Staff")
    };
    let params: IParamsCollection = {
      page: { size: 2000 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filter).build(),
      fields: {
        workers: 'id,name'
      }
    };
    let response = await firstValueFrom(this.workersService.all(params));
    this.workers = response.data;
    this.workers.unshift(allWorkers);
  }

  async loadBusiness() {
    let allBusiness = new Worker();
    allBusiness.id = "null";
    allBusiness.name = "Todos";
    let response = await firstValueFrom(this.businessService.all());
    this.business = response.data;
    this.business.unshift(allBusiness);
  }


  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.loadData();
  }

  async save() {
    let transactionSuccess = false;
    let failStr: string = "";

    if (this.isAdvancePayment) {
      let percent = Number(this.advancePaymentPercent);
      if (isNaN(percent) || percent < 0 || percent > 100) {
        this.messageService.add({ severity: 'error', detail: 'El % de anticipo debe estar entre 0 y 100.' });
        return;
      }
    }

    let workerBusinessKeys = new Set([
      ...Object.keys(this.selectedCases),
      ...Object.keys(this.selectedBillableItems),
      ...Object.keys(this.selectedChargedByWorker)
    ]);

    for (const workerBusinessKey of workerBusinessKeys) {

      let [workerId, businessId] = workerBusinessKey.split('|');

      let cases = this.selectedCases[workerBusinessKey] || [];
      let billableItems = this.selectedBillableItems[workerBusinessKey] || [];
      let chargedByWorker = this.selectedChargedByWorker[workerBusinessKey] || [];

      if (cases.length === 0 && billableItems.length === 0 && chargedByWorker.length === 0) {
        continue;
      }

      let data = {
        date: this.selectedDate.toISOString(),
        isAdvancePayment: this.isAdvancePayment,
        advancePaymentPercent: this.isAdvancePayment ? this.advancePaymentPercent : null,
        businessId: businessId,
        jobIds: cases.map(n => n.jobId!),
        billableItemsIds: billableItems.map(n => n.id!),
        chargedByWorkerIds: chargedByWorker.map(n => n.id!),
      };

      this.displayModal = false;
      try {

        let result: any = await firstValueFrom(this.transactionsService.workerTransactionByJobs(workerId, data));
        if (!result.success) {
          let workerName = this.workers.find((m: any) => m.id == workerId)?.name || "Desconocido";
          let businessName = this.business.find((m: any) => m.id == businessId)?.name || "Desconocido";
          failStr += `Operario: ${workerName}; Sociedad: ${businessName}\n`;
        } else {
          transactionSuccess = true;
        }
      } catch (error) {
        console.error("Error en la transacción:", error);
      }
    }

    if (transactionSuccess) {
      this.messageService.add({ closable: true, severity: 'success', summary: "Correcto", detail: "Factura generada correctamente." });
      if (this.type == "worker_invoice_request") {

        let params: IParamsCollection = {
          filter: FilterBuilder.fromObject({ transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transaction.transactionTypeId), code: new Filter(FilterOperation.equals, 'code', '', "accepted") }).build()
        }
        let response = await firstValueFrom(this.transactionsStatesService.all(params));
        let transactionState = response.data[0];
        if (transactionState != null) {
          this.transaction.transactionStateId = transactionState.id;
          await firstValueFrom(this.transactionsService.save(this.transaction));

          this.router.navigate(['/transactions/worker_invoice_request']);
        }


      }
      this.loadData();
    }

    if (failStr !== "") {
      this.confirmationService.confirm({
        message: failStr,
        header: "Facturas no generadas",
        acceptLabel: "Aceptar",
        icon: 'pi pi-exclamation-triangle',
        accept: () => { }
      });
    }
  }

  updateHeaderTotals(workerId: string, businessId: string) {
    let key = `${workerId}|${businessId}`;

    // Obtener los elementos seleccionados
    let selectedCases = this.selectedCases[key] || [];
    let selectedBillableItems = this.selectedBillableItems[key] || [];
    let selectedChargedByWorker = this.selectedChargedByWorker[key] || [];

    // Calcular subtotal y taxes
    let subtotal = selectedCases.reduce((sum, c) => sum + (c.total || 0), 0) +
      selectedBillableItems.reduce((sum, item) => sum + ((item.price * item.quantity) || 0), 0) +
      selectedChargedByWorker.reduce((sum, item) => sum + ((item.unitPrice * item.quantity) || 0), 0);
    let taxAmount = selectedCases.reduce((sum, c) => sum + (c.taxAmount || 0), 0) +
      selectedBillableItems.reduce((sum, item) => sum + (item.taxAmount || 0), 0) +
      selectedChargedByWorker.reduce((sum, item) => sum + (item.taxAmount || 0), 0);

    // Buscar el índice del workerBusiness correspondiente
    let index = this.workerBusinesses.findIndex(wb => wb.workerId === workerId && wb.businessId === businessId);

    if (index !== -1) {
      // Crear una nueva referencia para que Angular detecte el cambio
      this.workerBusinesses[index] = {
        ...this.workerBusinesses[index],
        subtotal,
        taxAmount,
        total: subtotal + taxAmount
      };
    }
  }

  getSubtotalSelected(): number {
    let allSelectedCases = Object.values(this.selectedCases).flat();
    let allSelectedBillableItems = Object.values(this.selectedBillableItems).flat();
    let allSelectedChargedByWorker = Object.values(this.selectedChargedByWorker).flat();

    return allSelectedCases.reduce((acc, line) => acc + (line.subtotal || 0), 0) +
      allSelectedBillableItems.reduce((acc, item) => acc + ((item.price * item.quantity) || 0), 0) +
      allSelectedChargedByWorker.reduce((acc, item) => acc + ((item.price * item.quantity) || 0), 0);
  }

  getAmountSelected(): number {
    let allSelectedCases = Object.values(this.selectedCases).flat();
    let allSelectedBillableItems = Object.values(this.selectedBillableItems).flat();
    let allSelectedChargedByWorker = Object.values(this.selectedChargedByWorker).flat();

    return allSelectedCases.reduce((acc, line) => acc + (line.taxAmount || 0), 0) +
      allSelectedBillableItems.reduce((acc, item) => acc + (item.taxAmount || 0), 0) +
      allSelectedChargedByWorker.reduce((acc, item) => acc + (item.taxAmount || 0), 0);
  }

  getTotalSelected(): number {
    let allSelectedCases = Object.values(this.selectedCases).flat();
    let allSelectedBillableItems = Object.values(this.selectedBillableItems).flat();
    let allSelectedChargedByWorker = Object.values(this.selectedChargedByWorker).flat();

    return allSelectedCases.reduce((acc, line) => acc + (line.total || 0), 0) +
      allSelectedBillableItems.reduce((acc, item) => acc + ((item.price * item.quantity || 0) + (item.taxAmount || 0)), 0) +
      allSelectedChargedByWorker.reduce((acc, item) => acc + ((item.price * item.quantity || 0) + (item.taxAmount || 0)), 0);
  }

  showModal() {
    if (this.hasSelectedCases() || this.hasSelectedBillableItems()) {
      this.selectedDate = new Date();
      this.displayModal = true;
    } else {
      this.messageService.add({ closable: true, severity: 'error', detail: "Debe seleccionar al menos un trabajo o un concepto facturable" });
    }
  }

  hideModal() {
    this.displayModal = false;
  }


  groupBy<T>(array: T[], key: keyof T): Record<string, T[]> {
    return array.reduce((result, currentValue) => {
      const groupKey = currentValue[key] as unknown as string;
      // Si el grupo para esta clave no existe, lo crea
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      // Agrega el elemento actual al grupo correspondiente
      result[groupKey].push(currentValue);
      return result;
    }, {} as Record<string, T[]>);
  }


  hasSelectedCases(): boolean {
    return Object.values(this.selectedCases).some(selectedList => selectedList.length > 0);
  }

  hasSelectedBillableItems(): boolean {
    return Object.values(this.selectedBillableItems).some(selectedList => selectedList.length > 0);
  }


  getTotalBillableItem(billableItem: any): number {

    return (billableItem.quantity * billableItem.price) + billableItem.taxAmount;
  }

  getTotalChargedByWorker(chargedByWorker: any): number {
    return (chargedByWorker.quantity * chargedByWorker.price) + chargedByWorker.taxAmount;
  }

  hasNegativeTotal(): boolean {
    return this.workerBusinesses.some(workerBusiness => workerBusiness.total < 0);
  }

}
